"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailTargetFragmentDependencies = exports.emailTargetFragment = void 0;
exports.emailTargetFragment = `
fragment emailTargetFragment on EmailTarget {
  emailAddress
  id
  isConfirmed
  name
}
`.trim();
exports.emailTargetFragmentDependencies = [];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1haWxUYXJnZXRGcmFnbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9mcmFnbWVudHMvZW1haWxUYXJnZXRGcmFnbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG1CQUFtQixHQUFHOzs7Ozs7O0NBT2xDLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFSSxRQUFBLCtCQUErQixHQUFHLEVBQUUsQ0FBQyJ9